import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgContentCopy = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M5 20h11v2H5q-.824 0-1.412-.588A1.93 1.93 0 0 1 3 20V6h2zM18 2q.825 0 1.412.588Q20 3.176 20 4v12q0 .825-.588 1.412A1.93 1.93 0 0 1 18 18H9q-.825 0-1.412-.588A1.93 1.93 0 0 1 7 16V4q0-.824.588-1.412A1.93 1.93 0 0 1 9 2zM9 16h9V4H9z" })
});
export default SvgContentCopy;
